// gtm.js loads after the window load event so its tags don't compete with page hydration.
// Events pushed earlier wait in window.dataLayer and are processed once GTM starts.
// Order confirmation is excluded on purpose: its purchase event must not wait.
const IMMEDIATE_GTM_PATH_PREFIXES = ['/store/order/confirmation'] as const;

export function isDeferredGtmPathname(pathname: string | undefined): boolean {
  if (!pathname) return false;

  const localePattern = /^\/[a-z]{2}-[a-z]{2,3}(\/|$)/;
  const pathWithoutLocale = pathname
    .split(/[?#]/)[0]
    .replace(localePattern, '/');

  return !IMMEDIATE_GTM_PATH_PREFIXES.some((prefix) =>
    pathWithoutLocale.startsWith(prefix),
  );
}
